module.exports = __webpack_public_path__ + "static/media/sre-documents-icon.724ec3eb.svg";